<div class="border-top pd-50" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="100px">
    <div class="" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
        <h3 class="rm-margin">{{ "CONTACT" | translate }}</h3>
        <span class="yellow-line" fxFlexAlign="stretch"></span>
        <div fxFlexAlign="start" class="" fxLayout="row" fxLayoutGap="20px">
            <mat-icon svgIcon="phone-bold"></mat-icon>
            <span> +49 (0) 2202 2512311</span>
        </div>
        <div fxFlexAlign="start" class="" fxLayout="row" fxLayoutGap="20px">
            <mat-icon svgIcon="phone-bold"></mat-icon>
            <span> +49 (0) 2202 2512312</span>
        </div>

        <div fxFlexAlign="start" class="" fxLayout="row" fxLayoutGap="20px">
            <mat-icon svgIcon="mail"></mat-icon>
            <span>info@dpigold.com</span>
        </div>
    </div>

    <div class="" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
        <h3 class="rm-margin">{{ "ADDRESS" | translate }}</h3>
        <span class="yellow-line" fxFlexAlign="stretch"></span>
        <div fxFlexAlign="start" class="" fxLayout="row" fxLayoutGap="20px">
            <mat-icon svgIcon="pin-bold"></mat-icon>
            <span>DPI Deutsche Premium Investment GmbH
        Paffrather Str. 315
        51469 Bergisch Gladbach</span>
        </div>

    </div>
</div>
